import React from 'react';
import styles from './SummaryTotals.scss';

export default ({ ...props }) => (
  <tr {...props}>
    <td></td>
    <td><div className={styles.divider}></div></td>
    <td><div className={styles.divider}></div></td>
    <td><div className={styles.divider}></div></td>
  </tr>
);



// WEBPACK FOOTER //
// ./webpack/components/Elements/SummaryTotals/Break.js